import sv from 'date-fns/locale/sv';

import { formatTz } from './dateUtils';

const formatPropositionDate = (date: Date): string =>
  formatTz(date, "EEEE d MMM 'före kl' HH.mm", { locale: sv });

export default formatPropositionDate;
